"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var getValueAsString = function getValueAsString(value, _ref) {
  var valueAccessor = _ref.valueAccessor;
  var isValueArray = Array.isArray(value);

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || !isValueArray && (0, _typeof2.default)(value) === 'object') {
    return valueAccessor(value);
  }

  if (isValueArray) {
    return value.map(function (item) {
      return valueAccessor(item);
    }).join(',');
  }
};

var _default = getValueAsString;
exports.default = _default;